
import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const AddServices = async (
    name,
    description,
    unitlabel,
    metered
  ) => {
    try {
      const data = JSON.stringify({
        svc: "feemodulenew",
        pid: "AddServices",
        dat: {
            name: name,
            description: description,
            unitlabel: unitlabel,
            metered: metered
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
};

export const ListServices = async (
    serviceId,
    serviceName,
    description,
    unitlabel,
    metered
) => {
  try {
    const data = JSON.stringify({
      svc: "feemodulenew",
      pid: "ListServices",
      dat: {
          id: serviceId,
          name: serviceName,
          description: description,
          unitlabel: unitlabel,
          metered: metered
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const UpdateServices = async (
  id,
  name,
  description,
  unitlabel,
  metered
) => {
  try {
    const data = JSON.stringify({
      svc: "feemodulenew",
      pid: "UpdateServices",
      dat: {
          id: id,
          name: name,
          description: description,
          unitlabel: unitlabel,
          metered: metered
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const DeleteServices = async (
  id
) => {
  try {
    const data = JSON.stringify({
      svc: "feemodulenew",
      pid: "DeleteServices",
      dat: {
          id: id
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const AddServicePrices = async (
  location,
  serviceid,
  pricetype,
  currency,
  unitprice,
  effectivefrom,
  effectiveto
) => {
  try {
    const data = JSON.stringify({
      svc: "feemodulenew",
      pid: "AddServicePrices",
      dat: {
        location: location,
        serviceid: serviceid,
        pricetype: pricetype,
        currency: currency,
        unitprice: unitprice,
        effectivefrom: effectivefrom,
        effectiveto: effectiveto
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ListServicePrices = async (
  location
) => {
  try {
    const data = JSON.stringify({
      svc: "feemodulenew",
      pid: "ListServicePrices",
      dat: {
        location: location
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const UpdateServicePrices = async (
  location,
  priceid,
  serviceid,
  pricetype,
  currency,
  unitprice,
  effectivefrom,
  effectiveto
) => {
  try {
    const data = JSON.stringify({
      svc: "feemodulenew",
      pid: "UpdateServicePrices",
      dat: {
        location: location,
        priceid: priceid,
        serviceid: serviceid,
        pricetype: pricetype,
        currency: currency,
        unitprice: unitprice,
        effectivefrom: effectivefrom,
        effectiveto: effectiveto
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const DeleteServicePrices = async (
  location,
  priceid
) => {
  try {
    const data = JSON.stringify({
      svc: "feemodulenew",
      pid: "DeleteServicePrices",
      dat: {
        location: location,
        priceid: priceid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const AddPackages = async (
  location,
  name,
  description,
  includeallservices
) => {
  try {
    const data = JSON.stringify({
      svc: "feemodulenew",
      pid: "AddPackages",
      dat: {
        location: location,
        name: name,
        description: description,
        includeallservices: includeallservices
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

